import React, {useEffect, useState} from "react";
import enJson from './locales/en.json'
import jaJson from './locales/ja.json'
import i18n from 'i18next'
import {initReactI18next, TFunction, useTranslation} from "react-i18next";
import {
    AppBar,
    Button,
    CircularProgress,
    Dialog,
    List,
    ListItem,
    ListItemText,
    makeStyles,
    Toolbar,
    Typography
} from "@material-ui/core";
import Box from "@material-ui/core/Box"
import twoPhase from './lib/twoPhase'
import {RouteComponentProps} from "react-router-dom";
import {getAuth, onAuthStateChanged, signInWithRedirect, signOut, TwitterAuthProvider} from 'firebase/auth';
import {getFirebaseConfig} from './config/firebase-config';
import {initializeApp} from 'firebase/app';

i18n.use(initReactI18next).init({
    resources: {
        en: {translation: enJson},
        ja: {translation: jaJson}
    },
    lng: 'ja',
    fallbackLng: 'ja',
    interpolation: {escapeValue: false}
}).then()

const Home: React.FC<RouteComponentProps> = (props: RouteComponentProps) => {
    const useStyles = makeStyles(() => ({
        container: {
            margin: '0 auto',
            padding: '20px',
            maxWidth: '500px'
        },
        link: {
            margin: '20px 0'
        },
        headerItem: {
            marginBottom: '10px'
        },
        button: {
            width: '200px'
        },
        progress: {
            marginTop: '20px'
        }
    }))
    const classes = useStyles()

    const [t, i18n] = useTranslation()
    const [open, setOpen] = useState(false)
    const [openWithVirtual, setOpenWithVirtual] = useState(false)
    const [openWithoutCube, setOpenWithoutCube] = useState(false)
    const [lang, setLang] = useState('ja')
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [userName, setUserName] = useState("")
    const moveCountList = [2, 3, 4, 5, 6, 7, 8]

    useEffect(() => {
        const firebaseAppConfig = getFirebaseConfig();
        initializeApp(firebaseAppConfig)
        twoPhase.initialize()
        const unsubscribed = onAuthStateChanged(getAuth(), authStateObserver)
        return () => {
            unsubscribed()
        }
    }, [])

    useEffect(() => {
        if (localStorage.lang) {
            setLang(localStorage.lang)
            i18n.changeLanguage(localStorage.lang).then()
        } else {
            i18n.changeLanguage(lang).then()
        }
    }, [lang, i18n])

    const handleLanguageChange = () => {
        const langTmp = lang === 'en' ? 'ja' : 'en'
        setLang(langTmp)
        localStorage.setItem('lang', langTmp)
    }

    const authStateObserver = (user: any) => {
        setIsLoading(false)
        if (user) {
            const name = getAuth().currentUser?.displayName
            setIsLoggedIn(true)
            setUserName(name ? name : "")
        } else {
            setIsLoggedIn(false)
            setUserName("")
        }
    }

    return (
        <div>
            <AppBar position={"relative"}>
                <Toolbar>
                    <Typography>{t('詰めキューブ')}</Typography>
                </Toolbar>
            </AppBar>
            <Box className={classes.container} maxWidth={"xs"} display={"flex"} flexDirection={"column"}>
                <Box className={classes.headerItem} display='flex' justifyContent={"space-between"}>
                    <LoginButton
                        isLoading={isLoading}
                        isLoggedIn={isLoggedIn}
                        t={t}
                        handleLoginClicked={() => {
                            const provider = new TwitterAuthProvider()
                            signInWithRedirect(getAuth(), provider)
                        }}
                        handleLogoutClicked={() => {
                            signOut(getAuth())
                        }}
                    />
                    <Button
                        variant='outlined'
                        color='default'
                        onClick={handleLanguageChange}
                    >{t('言語変更')}</Button>
                </Box>
                {userName !== "" &&
                    <Box className={classes.headerItem} display={"flex"} justifyContent={"flex-start"}>
                        {t('ユーザー名')}{getAuth().currentUser?.displayName}
                    </Box>
                }
                <Box display={"flex"} justifyContent={"center"}>
                    <Typography variant='h3' align='center'>{t('詰めキューブ')}</Typography>
                </Box>
                {isLoading &&
                    <Box className={classes.progress} display={"flex"} justifyContent={"center"}>
                        <CircularProgress />
                    </Box>
                }
                {!isLoading &&
                    <Box className={classes.link} display={"flex"} justifyContent={"center"}>
                        <Button className={classes.button} variant='contained' size='large'
                                onClick={() => props.history.push('/about')}>
                            {t('遊び方')}
                        </Button>
                    </Box>
                }
                {!isLoading &&
                    <Box className={classes.link} display={"flex"} justifyContent={"center"}>
                        <Button className={classes.button} variant='contained' size='large' onClick={() => setOpen(true)}>
                            {t('スタート')}
                        </Button>
                    </Box>
                }
                {!isLoading &&
                    <Box className={classes.link} display={"flex"} justifyContent={"center"}>
                        <Button className={classes.button} variant='contained' size='large'
                                onClick={() => setOpenWithVirtual(true)}>
                            {t('バーチャルキューブ')}<br/>
                            {t('でスタート')}
                        </Button>
                    </Box>
                }
                {!isLoading &&
                    <Box className={classes.link} display={"flex"} justifyContent={"center"}>
                        <Button className={classes.button} variant='contained' size='large'
                                onClick={() => setOpenWithoutCube(true)}>
                            {t('スクランブル画像のみでスタート')}
                        </Button>
                    </Box>
                }
                {!isLoading && isLoggedIn &&
                    <Box className={classes.link} display={"flex"} justifyContent={"center"}>
                        <Button className={classes.button} variant='contained' size='large'
                                onClick={() => props.history.push('/results')}>
                            {t('自分の記録')}
                        </Button>
                    </Box>
                }
                {!isLoading && isLoggedIn &&
                    <Box className={classes.link} display={"flex"} justifyContent={"center"}>
                        <Button className={classes.button} variant='contained' size='large'
                                onClick={() => props.history.push('/total_ranking')}>
                            {t('総合ランキング')}
                        </Button>
                    </Box>
                }
                {!isLoading && isLoggedIn &&
                    <Box className={classes.link} display={"flex"} justifyContent={"center"}>
                        <Button className={classes.button} variant='contained' size='large'
                                onClick={() => props.history.push('/daily_ranking')}>
                            {t('デイリーランキング')}
                        </Button>
                    </Box>
                }
            </Box>
            <Dialog onClose={() => setOpen(false)} open={open}>
                <List>
                    {moveCountList.map((moveCount =>
                            <ListItem button key={moveCount}
                                      onClick={() => props.history.push({
                                          pathname: 'game',
                                          state: {
                                              moveCount: moveCount
                                          }
                                      })}>
                                <ListItemText primary={t('Challenge') + moveCount + t('手スクランブルに挑戦')}/>
                            </ListItem>
                    ))}
                </List>
            </Dialog>
            <Dialog onClose={() => setOpenWithVirtual(false)} open={openWithVirtual}>
                <List>
                    {moveCountList.map((moveCount =>
                            <ListItem button key={moveCount}
                                      onClick={() => props.history.push({
                                          pathname: 'gameWithVirtual',
                                          state: {
                                              moveCount: moveCount
                                          }
                                      })}>
                                <ListItemText primary={t('Challenge') + moveCount + t('手スクランブルに挑戦')}/>
                            </ListItem>
                    ))}
                </List>
            </Dialog>
            <Dialog onClose={() => setOpenWithoutCube(false)} open={openWithoutCube}>
                <List>
                    {moveCountList.map((moveCount =>
                            <ListItem button key={moveCount}
                                      onClick={() => props.history.push({
                                          pathname: 'gameWithoutCube',
                                          state: {
                                              moveCount: moveCount
                                          }
                                      })}>
                                <ListItemText primary={t('Challenge') + moveCount + t('手スクランブルに挑戦')}/>
                            </ListItem>
                    ))}
                </List>
            </Dialog>
        </div>
    )
}

interface LoginButtonProps {
    isLoading: boolean,
    isLoggedIn: boolean,
    t: TFunction<"translation">,
    handleLoginClicked: () => any,
    handleLogoutClicked: () => any
}

const LoginButton = (
    props: LoginButtonProps
) => {
    if (props.isLoading) {
        return  (
            <Button
                variant='contained'
                color='primary'
            >{props.t('読み込み中')}</Button>
        )
    } else {
        if (props.isLoggedIn) {
            return (
                <Button
                    variant='contained'
                    color='primary'
                    onClick={props.handleLogoutClicked}
                >{props.t('ログアウト')}</Button>
            )
        } else {
            return (
                <div onClick={props.handleLoginClicked}>
                    <img
                        src={`${process.env.PUBLIC_URL}/sign-in-with-twitter.png`}
                        alt='login' />
                </div>
            )
        }
    }
}

export default Home